module.exports = __webpack_public_path__ + "static/media/phone.8030a112.svg";